import QuickViewAction from './QuickViewAction';
export default QuickViewAction;
